/**
 * Sprint 39 — Formatea un monto en CENTAVOS (Int) como string monetario.
 * Ejemplo: formatPrecio(1250) → "$12.50".
 *
 * El sistema ahora maneja todo dinero en centavos para evitar errores
 * IEEE-754. Esta función es el único lugar de la app que divide entre
 * 100 al mostrar.
 */
export function formatPrecio(centavos: number, simbolo = '$', locale = 'es-MX'): string {
  if (!Number.isFinite(centavos)) {
    return `${simbolo}0.00`;
  }
  const pesos = centavos / 100;
  const numero = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(pesos);
  return `${simbolo}${numero}`;
}

export function formatFecha(fecha: Date | string, locale = 'es-MX'): string {
  const d = typeof fecha === 'string' ? new Date(fecha) : fecha;
  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(d);
}
